import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { Entity } from '@apps/auth/domain/models/back';
import { CompareLowerString2 } from '@common/services';
import { IUsersState, usersInitialState } from '@apps/back/store/auth/users/users.common';
import { Site } from '@apps/priv/models/site';
import { EntityBackupDefinition } from '@apps/auth/domain/models/back/entity-backup-definition';

export type IEntitiesState = EntityState<Entity>;
export const entitiesAdapter: EntityAdapter<Entity> = createEntityAdapter<Entity>({
    selectId: (entity: Entity): string => entity.id,
    sortComparer: (ea, eb) =>
    {
        if (ea.withExploit)
        {
            if (eb.withExploit)
            {
                return ea.name.toUpperCase().localeCompare(eb.name.toUpperCase());
            }
            else
            {
                return -1;
            }
        }
        else if (eb.withExploit)
        {
            return 1;
        }

        return ea.name.toUpperCase().localeCompare(eb.name.toUpperCase());
    }
});
export const entitiesInitialState: IEntitiesState = entitiesAdapter.getInitialState();

// Spécifique à Entities
type ISitesState = EntityState<Site>;
export const sitesAdapter: EntityAdapter<Site> = createEntityAdapter<Site>({
    selectId: (site: Site): string => site.id,
    sortComparer: CompareLowerString2<Site>((site: Site): string => site.name)
});
export const sitesInitialState: ISitesState = sitesAdapter.getInitialState();

export class DetailedEntity
{
    entity: Entity = null;
    users: IUsersState = usersInitialState;
    sites: ISitesState = sitesInitialState;
    referents: IUsersState = usersInitialState;
}
